import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { get, post, del } from '../lib/apiClient';

export interface TeamMemberData {
  id: string;
  name: string;
  email: string;
  avatar_url: string | null;
  role: 'owner' | 'admin' | 'member';
  status: 'active' | 'inactive';
  joined_at: string | null;
}

export interface InvitationData {
  id: string;
  email: string;
  name: string;
  role: 'admin' | 'member';
  status: string;
  expires_at: string;
  invited_by_name: string | null;
}

interface TeamData {
  members: TeamMemberData[];
  invitations: InvitationData[];
}

export function useTeamQuery(enabled = true) {
  return useQuery({
    queryKey: ['team'],
    queryFn: () => get<TeamData>('settings/team/members'),
    enabled,
  });
}

export function useInviteMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: { email: string; name: string; role: string }) =>
      post('settings/team/invite', data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['team'] });
    },
  });
}

export function useRemoveMemberMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (userId: string) => del(`settings/team/members/${userId}`),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['team'] });
    },
  });
}

export function useRevokeInviteMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (inviteId: string) => del(`settings/team/invites/${inviteId}`),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['team'] });
    },
  });
}
